import React from 'react';
import PropTypes from 'prop-types';
import css from './Sections.module.css';
import bannerImg from '../../../assets/trust-safety-banner-img.png';

function SectionHero({ intl }) {
  return (
    <div className={css.heroContainer}>
      <div className={css.fixedWidthContainer}>
        <div className={css.heroInfo}>
          <div className={css.sellersInfoInner}>
            <h1>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionHero.title' })}</h1>
            <p>{intl.formatMessage({ id: 'TrustAndSafetyPage.SectionHero.description' })}</p>
          </div>
        </div>
        <div className={css.heroImg}>
          <img src={bannerImg} alt="banner" />
        </div>
      </div>
    </div>
  );
}

export default SectionHero;